jQuery(document).ready(function() {


    // Sync fields
    if ( jQuery('.contact-form-home #support_light') ) {

        jQuery(".contact-form-home input[name=name]").on("input", function() {
            jQuery(".supportform_form input[name=name]").val(this.value);
        });
        jQuery(".supportform_form input[name=name]").on("input", function() {
            jQuery(".contact-form-home input[name=name]").val(this.value);
        });

        jQuery(".contact-form-home input[name=email]").on("input", function() {
            jQuery(".supportform_form input[name=email]").val(this.value);
        });
        jQuery(".supportform_form input[name=email]").on("input", function() {
            jQuery(".contact-form-home input[name=email]").val(this.value);
        });

    }
    
    
    // Form Ajax Submit
    jQuery('.supportform').each(function() {
        FormSubmitAction(this);
    });

    // Set first tab to active tab
    jQuery('.tabpanel-1').each(function(index) {
        jQuery(this).addClass('active');
    });

});



var FormSubmitAction = function(form_container) {
    var form = jQuery(form_container).find('form').first();
    form.preventDoubleSubmission();
    var error = jQuery(form_container).find('.form-error-container').first();
    var success = jQuery(form_container).find('.form-success-container').first();

    var form_home = jQuery('.supportform.contact-form-home').first();
    if (form_home) {
        var error_home = form_home.parent().find('.form-error-container').first();
        var success_home = form_home.parent().find('.form-success-container').first();
    }

    form.submit(function(event) {
        event.preventDefault();
        form.find('button .fa-spinner').removeClass('d-none');

        jQuery.ajax({
            type: 'POST',
            url: form.attr('action'),
            data: form.serialize()
        }).done(function(response) {
            success.removeClass('d-none');
            form.addClass('d-none');
            jQuery('.supportform-header').addClass('d-none');
            // if (form_home) {
            //     form_home.addClass('d-none');
            //     success_home.removeClass('d-none');
            // }
        }).fail(function(data) {
            error.removeClass('d-none');
            form.addClass('d-none');

            // if (form_home) {
            //     form_home.addClass('d-none');
            //     error_home.removeClass('d-none');
            // }
        });
    });
}


// jQuery plugin to prevent double submission of forms
jQuery.fn.preventDoubleSubmission = function() {
  jQuery(this).on('submit',function(e){
    var form = jQuery(this);
    if (form.data('submitted') === true) {
      // Previously submitted - don't submit again
      e.preventDefault();
    } else {
      // Mark it so that the next submit can be ignored
      form.data('submitted', true);
    }
  });

  // Keep chainability
  return this;
};